import React from "react";
import { object, string, bool, number } from "prop-types";
import classNames from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { Tabs, Tab } from "../../TabsAndAccordions";
import testData from "./testData";
import { Img } from "../../../sharedComponents/Images";
// eslint-disable-next-line import/no-cycle
import { Button } from "../../Button";
import * as styles from "./ThingsToDo.module.scss";

const cx = classNames.bind(styles);

const Tile = ({ excursion }) => (
	<div className={cx("tile")}>
		{excursion.title && (
			<div className={cx("tileHeader")}>
				<span className={cx("tileTitle")}>{excursion.title}</span>
			</div>
		)}

		<div className={cx("tileContentSplit")}>
			{excursion.image && (
				<div className={cx("tileImageContainer")}>
					<Img src={excursion.image} alt={excursion.title} />
				</div>
			)}
			<div className={cx("tileSplitContent")}>
				<div className={cx("tileSplitContentTop")}>
					{excursion.description && <p>{excursion.description}</p>}
				</div>
				{excursion.url && (
					<Button label="Learn More" to={excursion.url} iconPlacement="right" full />
				)}
			</div>
		</div>
	</div>
);

const GolfTile = ({ golfSite }) => (
	<div className={cx("tile", "hoverColor")}>
		<div className={cx("golfTileContent")}>
			{golfSite.title && <span className={cx("golfTileHeading")}>{golfSite.title}</span>}
			<div className={cx("golfTileDetails")}>
				<div className={cx("section")}>
					{golfSite.address && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Address</span>
							&nbsp;:&nbsp;{golfSite.address}
						</span>
					)}
					{golfSite.architect && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Architect</span>
							&nbsp;:&nbsp;{golfSite.architect}
						</span>
					)}
					{golfSite.telephone && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Telephome</span>
							&nbsp;:&nbsp;{golfSite.telephone}
						</span>
					)}
				</div>

				<div className={cx("section", "half")}>
					{golfSite.numHoles && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>No of Holes</span>
							&nbsp;:&nbsp;{golfSite.numHoles}
						</span>
					)}
					{golfSite.fairways && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Fairways</span>
							&nbsp;:&nbsp;{golfSite.fairways}
						</span>
					)}
					{golfSite.yardage && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Yardage</span>
							&nbsp;:&nbsp;{golfSite.yardage}
						</span>
					)}
					{golfSite.rating && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Rating</span>
							&nbsp;:&nbsp;{golfSite.rating}
						</span>
					)}
				</div>

				<div className={cx("section", "half")}>
					{golfSite.par && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Par</span>
							&nbsp;:&nbsp;{golfSite.par}
						</span>
					)}
					{golfSite.greens && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Greens</span>
							&nbsp;:&nbsp;{golfSite.greens}
						</span>
					)}
					{golfSite.spikes && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Spikes</span>
							&nbsp;:&nbsp;{golfSite.spikes}
						</span>
					)}
					{golfSite.slope && (
						<span className={cx("field")}>
							<span className={cx("fieldName")}>Slope</span>
							&nbsp;:&nbsp;{golfSite.slope}
						</span>
					)}
				</div>
			</div>
		</div>
	</div>
);

const SpaTile = ({ spaLocation }) => (
	<div className={cx("tile", "half", "hoverColor")}>
		<div className={cx("tileContent")}>
			{spaLocation.title && <div className={cx("tileContentHeader")}>Cocobay Resort Antigua</div>}

			{spaLocation.services && (
				<div className={cx("contentSection")}>
					<ul>
						{spaLocation.services.map(service => (
							<li>{service}</li>
						))}
					</ul>
				</div>
			)}

			{spaLocation.link && (
				<a href={spaLocation.link} className={cx("tileLink")}>
					Explore all services in this resort
				</a>
			)}
		</div>
	</div>
);

const ThingsToDo = ({
	title,
	maxNumberOfEntries,
	displayToursAndExcursions,
	displayGolf,
	displaySpas,
}) => {
	const excursions = testData.excursions.slice(0, maxNumberOfEntries);
	const spas = testData.spas.slice(0, maxNumberOfEntries);
	const golf = testData.golf.slice(0, maxNumberOfEntries);

	return (
		<div className={cx("container")}>
			{title && <h2>{title}</h2>}
			<Tabs activeKey="tours" variant="tide">
				{displayToursAndExcursions && excursions && (
					<Tab eventKey="tours" title="Tours and excursions">
						<div className={cx("tilesContainer")}>
							{excursions.map(excursion => (
								<Tile key={excursion.id} excursion={excursion} />
							))}
						</div>
						<div className={cx("tilesFooterContainer")}>
							<Button
								to="/en"
								className={cx("tilesFooterButton")}
								label="See all excursions in Antigua"
								outline
							/>
						</div>
					</Tab>
				)}
				{displayGolf && golf && (
					<Tab eventKey="golf" title="Golf">
						<div className={cx("tilesContainer")}>
							{golf.map(golfSite => (
								<GolfTile key={golfSite.id} golfSite={golfSite} />
							))}
						</div>
					</Tab>
				)}
				{displaySpas && spas && (
					<Tab eventKey="spas" title="Spas">
						<div className={cx("tilesContainer")}>
							{spas.map(spaLocation => (
								<SpaTile key={spaLocation.id} spaLocation={spaLocation} />
							))}
						</div>
						<div className={cx("tilesFooterContainer")}>
							<a href="/en" className={cx("tilesFooterButton")}>
								See all excursions in Antigua
							</a>
						</div>
					</Tab>
				)}
			</Tabs>
		</div>
	);
};

Tile.propTypes = {
	excursion: object.isRequired,
};

GolfTile.propTypes = {
	golfSite: object.isRequired,
};

SpaTile.propTypes = {
	spaLocation: object.isRequired,
};

ThingsToDo.propTypes = {
	title: string,
	maxNumberOfEntries: number,
	displayToursAndExcursions: bool,
	displayGolf: bool,
	displaySpas: bool,
};
ThingsToDo.defaultProps = {
	title: null,
	maxNumberOfEntries: null,
	displayToursAndExcursions: null,
	displayGolf: null,
	displaySpas: null,
};

export default ThingsToDo;
export { ThingsToDo };
